var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.771,45.164c0.595-6.734-5.683-8.699-8.174-8.699  c-9.656-0.002-19.315,0.001-28.972-0.008c1.39-3.025,3.085-11.046,0.95-22.097c-0.843-4.369-3.421-7.275-6.705-7.217  c-2.646,0.046-5.173,2.086-5.438,4.63c-0.29,2.797-0.977,6.78-1.627,9.504c-2.08,8.708-13.205,20.205-20.24,24.216v42.539  c4.772,2.697,9.947,3.641,15.474,3.536c8.732-0.167,33.675-0.021,38.195-0.051c3.199-0.021,6.389-1.547,7.923-5.409  c2.096-5.271-3.307-7.908-3.307-7.908s5.915,0.292,7.267-5.014c1.387-5.446-4.055-7.601-4.055-7.601  c3.68-0.402,6.036-1.36,6.927-4.677c1.047-3.907-1.466-6.841-5.444-8.539C91.148,52.31,97.225,51.328,97.771,45.164z M21.44,38.733  H5.19c-1.657,0-3,1.343-3,3v48.125c0,1.657,1.343,3,3,3h16.25c1.657,0,3-1.343,3-3V41.733C24.44,40.077,23.098,38.733,21.44,38.733z  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.765db8df0885b8471c600abaced89002.svg";
export { ForwardRef as ReactComponent };